module.exports = __webpack_public_path__ + "img/solution-3.b2df99f0.jpg";